<small *ngIf="rodape?.dataCriacao" class="pl-2">
  Última atualização em
  {{ data }}</small>
<br>
<small *ngIf="responsavel" class="pl-2">Usuário: {{ responsavel }}</small>
